import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {NestActions} from '../../../store/actionCreators';
import {QUERY_NEST_TRIGGER_SETTINGS} from '../../../lib/graphQL/nest/queries';
import SettingControllerContainer from './SettingControllerContainer';

class TriggerSettingsQueryContainer extends Component {

  render() {
    const {deviceUuid, targetId} = this.props;

    return (
      <Query query={QUERY_NEST_TRIGGER_SETTINGS} variables={{deviceUuid, targetId}}>
        {
          ({loading, error, data}) => {
            if (loading) {
              NestActions.setLoading();
              return null;
            }
            if (error) {
              NestActions.unsetLoading();
              return `Error!: ${error}`;
            }

            NestActions.unsetLoading();

            return (
              <SettingControllerContainer triggerSettings={data.getTriggerSettings}
                                          deviceType={deviceUuid.split('_')[0]}/>
            );
          }
        }
      </Query>
    );
  }
}

export default TriggerSettingsQueryContainer;


// WEBPACK FOOTER //
// ./src/app/nest/containers/TriggerSettingsQueryContainer.js